// extracted by mini-css-extract-plugin
export default {"ButtonWrapper":"Edge_ButtonWrapper__4kZ53","Button":"Edge_Button__Kv1Qr"};